import styled from 'styled-components';
import Button from 'components/Button';

export const Form = styled.form`
    width: 600px;
    max-width: 100%;
    margin: auto;
`;

export const Input = styled.input`
    color: white;
    margin-bottom: 10px;
    width: 100%;
    height: 40px;
    background: linear-gradient(344.2deg, #2C333A -71.57%, #1C1E22 59.28%, #121416 59.28%);
    box-shadow: inset 2px 3px 10px #070709, inset -2px -2px 10px rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    padding: 10px;
    font-family: 'Roboto';
    outline: 0;
    border: none;
    font-style: normal;
    font-weight: normal;
    margin-bottom: 10px;
    font-size: 15px;
    line-height: 100%;
    color: #D6E1EF;
    opacity: 0.8;
    &::placeholder{color: '#AAAAAA'}
    @media only screen and (max-width: 768px) {
        font-size: 15px;
        line-height: 100%;
    }
`;

export const PayButton = styled(Button)`
    min-width: 200px;
    height: 40px;
    border-radius: 400px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.9;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 10px;
    &:hover{
        opacity: 1;
    }
    &:active{
        opacity: 1;
    }
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
        flex-shrink: 0;
        margin-top: 10px;
    }
`;

export const ContainerSubtotalAmount = styled.div`
    width: 100%;
    text-align: center;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 100%;
    margin-bottom: 10px;
    color: #D6E1EF;
    opacity: 0.8;
    display: flex;
    align-items: space-between;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 0px 5px;
`;

export const EmailInput = styled.input`
    background-color: transparent;
    border: 0;
    outline: 0px;
`;